import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import { types } from './utils/constants-utils';
import DashboardLayout from './layouts/dashboard';
import LogoOnlyLayout from './layouts/LogoOnlyLayout';
//
import Login from './pages/Login';
import DashboardApp from './pages/DashboardApp';
import NotFound from './pages/Page404';
import Logs from './pages/Logs';
import PropertyMembers from './pages/PropertyMembers';

// ----------------------------------------------------------------------

const Router = ({ isLoggedIn, currentRole }) => {
  const isAdmin = currentRole === 'admin';
  let routes = [
    {
      path: '/',
      element: <LogoOnlyLayout />,
      children: [
        { path: 'login', element: <Login /> },
        { path: '404', element: <NotFound /> },
        { path: '/', element: <Navigate to="/dashboard/app" replace /> },
        { path: '*', element: <Navigate to="/login" /> }
      ]
    }
  ];
  if (isLoggedIn) {
    routes = [
      {
        path: '/dashboard',
        element: <DashboardLayout />,
        children: [
          { element: <Navigate to="/dashboard/members" replace /> },
          { path: 'app', element: <DashboardApp /> },
          { path: 'members', element: <PropertyMembers /> },
          { path: 'openings', element: <Logs category={types.logs.categories.opening} /> },
          {
            path: 'actions',
            element: isAdmin ? (
              <Logs category={types.logs.categories.action} />
            ) : (
              <Navigate to="/dashboard/members" replace />
            )
          }
        ]
      },
      {
        path: '/',
        element: <LogoOnlyLayout />,
        children: [
          { path: 'login', element: <Navigate to="/dashboard/members" replace /> },
          { path: '404', element: <NotFound /> },
          { path: '/', element: <Navigate to="/dashboard/members" replace /> },
          { path: '*', element: <Navigate to="/404" /> }
        ]
      },
      { path: '*', element: <Navigate to="/404" replace /> }
    ];
  }
  return useRoutes(routes);
};

export default Router;
